import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/utils/api";
import { AlertTriangle, FileText, ArrowRight, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ReceiptReminderBanner() {
  const [stats, setStats] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await api.get("/expenses/receipt-stats");
        setStats(res.data);
      } catch (e) { /* ignore */ }
    };
    fetchStats();
  }, []);

  if (dismissed || !stats || stats.missing_receipt === 0) return null;

  const pct = stats.total_expenses > 0
    ? Math.round((stats.with_receipt / stats.total_expenses) * 100)
    : 100;

  return (
    <div
      data-testid="receipt-reminder-banner"
      className="relative bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-xl p-4 mb-4"
    >
      <button
        onClick={() => setDismissed(true)}
        className="absolute top-3 right-3 text-amber-400 hover:text-amber-600 transition-colors"
        data-testid="receipt-reminder-dismiss"
      >
        <X className="h-4 w-4" />
      </button>

      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
          <FileText className="h-5 w-5 text-amber-600" />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="font-semibold text-amber-900 text-sm">
            {stats.missing_receipt} {stats.missing_receipt === 1 ? "Ausgabe" : "Ausgaben"} ohne Beleg
          </h4>
          <p className="text-sm text-amber-700 mt-0.5">
            Lade jetzt deine Belege hoch, damit dein Steuerberater alles auf einen Blick hat.
            Aktuell {pct}% vollständig.
          </p>

          {/* Progress bar */}
          <div className="mt-2 h-1.5 bg-amber-200 rounded-full overflow-hidden">
            <div
              className="h-full bg-amber-500 rounded-full transition-all duration-500"
              style={{ width: `${pct}%` }}
            />
          </div>

          <Button
            size="sm"
            variant="outline"
            className="mt-3 text-amber-800 border-amber-300 hover:bg-amber-100"
            onClick={() => navigate("/finances")}
            data-testid="receipt-reminder-action"
          >
            Belege hochladen <ArrowRight className="h-3.5 w-3.5 ml-1" />
          </Button>
        </div>
      </div>
    </div>
  );
}
